import { Route, Routes } from 'react-router-dom';

import { mapObject } from '@client/toolkit';

import { InvestmentCreateRoute } from './investment-create/investment-create.route';
import { InvestmentListRoute } from './investment-list/investment-list.route';
import { InvestmentRoute } from './investment/investment.route';

export const InvestmentsPaths = {
  InvestmentList: '/investments',
  InvestmentCreate: '/investments/investment-create',
  Investment: '/investments/:id',
};

const RouterPaths = mapObject(InvestmentsPaths, (val: string) => val.replace(InvestmentsPaths.InvestmentList, ''));

export const InvestmentsRouter = () => (
  <Routes>
    <Route path="/" element={<InvestmentListRoute />}>
      <Route path={RouterPaths.InvestmentCreate} element={<InvestmentCreateRoute />} />
    </Route>

    <Route path={RouterPaths.Investment} element={<InvestmentRoute />} />
  </Routes>
);
